import * as v from 'valibot';
import { HumanParticipantSchema } from './human-participant';

export const UserInfoCommandSchema = v.pick(HumanParticipantSchema, [
  'avatar',
  'uid',
]);
